import { ENUM__page_type } from '@/enums/ENUM__page_type';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_effect } from '@/hooks/_base/use_effect';
import { use_navigate_ud } from '@/hooks/_base/use_navigate_ud';
import { use_slice_generation, use_slice_user, use_slice_workspace } from '@/hooks/store/use_slices';
import { REMOTE__user_task_load_generations_by_generation_id } from '@/state/generation/user_task/entity/REMOTE__user_task_load_generations_by_generation_id';
import { remote_user_task_get_shared_by_generation_id } from '@/state/generation/user_task/entity/remote_user_task_get_shared_by_generation_id';
import { store } from '@/state/store';
import { LOCAL__workspace_set_is_all_data_loaded } from '@/state/workspace/entity/LOCAL__workspace_set_is_all_data_loaded';
import { save_url_to_store_for_redirect_after_auth } from '@/utils/utils_client';
import { set_current_generation, set_current_workspace, try_set_default_workspace } from '@/utils/utils_client_workspace_child_entity_viewers';
import { try_load_shared_user_task_from_server_by_generation_id } from '@/utils/utils_shared_entity';
import { DTO_RESPONSE__success } from '@shared/network/DTO_RESPONSE__success';
import { useParams } from 'react-router-dom';

export function WATCHER_SLUG__page_generation() {
  const dispatch = use_dispatch();
  const navigate = use_navigate_ud();

  const { generation_id: generation_id_from_slug } = useParams();

  const { auth_token } = use_slice_user(['auth_token']);
  const { generation_current, generations_map } = use_slice_generation(['generation_current', 'generations_map']);
  const { is_all_data_loaded, workspace_current } = use_slice_workspace(['is_all_data_loaded', 'workspace_current']);

  /*
   * EFFECTS
   */
  use_effect(() => void set_entity_and_workspace_from_slug(), [is_all_data_loaded]);
  use_effect(() => void load_shared_entity_for_guest(), [auth_token]);

  use_effect(() => {
    if (!is_all_data_loaded) return;
    if (generation_id_from_slug === generation_current._id) return; //slug and data are already synced

    //could be stub when from user deleted permissions to view entities
    let entity_id = generation_current.is_stub() ? '' : generation_current._id;

    let url = ENUM__page_type.BUILD_PATH_GENERATION(entity_id);

    void navigate(url, { replace: true, keep_search_params: true });
  }, [generation_current, is_all_data_loaded, generation_id_from_slug]);

  /*
   * METHODS
   */

  async function set_entity_and_workspace_from_slug() {
    if (!auth_token) return; //not authorized
    if (!is_all_data_loaded) return; // not all data loaded

    //already equal
    if (generation_current._id === generation_id_from_slug && !generation_current.is_stub()) return set_current_workspace(generation_current.workspace_id);

    if (!generation_current.is_stub()) return; //already established

    let entity_from_slug = [...generations_map.values()].find(item => item._id == generation_id_from_slug);

    if (!entity_from_slug && generation_id_from_slug) {
      //try load user_task_id generations by generation_id first
      await store.dispatch(REMOTE__user_task_load_generations_by_generation_id(generation_id_from_slug));

      let generations = Array.from(store.getState().slice_generation.user_tasks_map.values()).flatMap(user_task => user_task.generations);

      entity_from_slug = generations.find(item => item._id == generation_id_from_slug);
    }

    if (!entity_from_slug && generation_id_from_slug) {
      entity_from_slug = await try_load_shared_user_task_from_server_by_generation_id(generation_id_from_slug);
    }

    if (entity_from_slug) {
      await set_current_generation(entity_from_slug._id);

      set_current_workspace(entity_from_slug.workspace_id);
    } else if (workspace_current.is_stub()) {
      await try_set_default_workspace();
    }
  }

  async function load_shared_entity_for_guest() {
    if (auth_token) return; //user is authorized or going to authorize
    if (!generation_current.is_stub()) return; //already establshed

    if (!generation_id_from_slug) {
      //page without params
      //need save it and navigate to auth
      save_url_to_store_for_redirect_after_auth();

      await navigate(ENUM__page_type.AUTH);
      return;
    }

    let action_result = await dispatch(remote_user_task_get_shared_by_generation_id(generation_id_from_slug));

    if (action_result.payload instanceof DTO_RESPONSE__success) {
      let generation_current = await set_current_generation(generation_id_from_slug);

      set_current_workspace(generation_current.workspace_id);

      dispatch(LOCAL__workspace_set_is_all_data_loaded(true));
    } else {
      save_url_to_store_for_redirect_after_auth();

      await navigate(ENUM__page_type.AUTH);
    }
  }

  return <></>;
}
